import styled from "styled-components";

export const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
